<template>
  <b-container style="width:600px;">
    <b-card>
      <h3>Manage SproutVideo</h3>
      <br />
      <b-card-text>
        <b-input-group prepend="Domain">
          <b-form-input trim autocomplete="off" v-model="form.domain" @keyup.enter="checkDomain"
            type="text"></b-form-input>
          <b-input-group-append>
            <b-button variant="success" @click="checkDomain">Check
              <b-spinner v-if="this.IsChecking" class="m-1" label="Spinning" small />
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <ul class="mt-3 mb-3">
          <li v-for="error in sv_errors" :key="error" style="color:red">{{ error }}</li>
        </ul>

        <div v-if="isChecked">
          Allowed Accounts:
          <span v-if="allowed && allowed.length" class="text-success font-weight-bold">{{ allowed.map(account => account).join(', ') }}</span>
          <span v-else class="text-muted">None</span>
          <b-form class="mt-3 mb-2">
            <b-form-group label="Add or remove accounts for the domain.">
              <b-form-select v-model="selectedValues" :options="options" multiple :select-size="12"></b-form-select>
            </b-form-group>
          </b-form>
          <b-button class="mt-2 mr-2" 
            size="sm" 
            text="Add" variant="primary" @click="addDomain"
            :disabled="is_button_disabled">
            Add
            <b-spinner v-if="this.IsAdding" class="m-1" label="Spinning" small />

          </b-button>
          <b-button class="mt-2" size="sm" text="Button" variant="primary" @click="removeDomain"
            :disabled="is_button_disabled">
            Remove
            <b-spinner v-if="this.IsRemoving" class="m-1" label="Spinning" small />
          </b-button>
        </div>

      </b-card-text>
    </b-card>
  </b-container>
</template>

<script>
import {checkDomain, addDomain, removeDomain} from "../../utils/twa-api"

export default {
  data() {
    return {
      form: {
        domain: this.$route.params.domain
      },
      IsChecking: false,
      IsAdding: false,
      IsRemoving: false,
      hasError: false,
      allowed: null,
      sproutVideoAccounts: {
        "sprout1": "1",
        "sprout2": "2",
        "sprout3": "3",
        "sprout4": "4",
        "sprout5": "5",
        "sprout6": "6",
        "sprout7-8": "7-8",
        "sprout9-10": "9-10",
        "sprout11-12": "11-12",
        "sprout13-15": "13-15",
        "sprout16-18": "16-18",
      },
    selectedValues: [],
    isChecked: false,
    sv_errors: []
    }
  },
  computed: {
    concatenatedValues() {
      return this.selectedValues.join('_');
    },
    options() {
      return Object.keys(this.sproutVideoAccounts).map(key => {
        return { value: this.sproutVideoAccounts[key], text: key };
      });
    },
    is_button_disabled() {
      return this.selectedValues.length == 0
    }
  },
  methods: {
    handleLoginEvent(data) {
      this.isAuthenticated = data.loggedIn
      this.profile = data.profile
    },
    handleApiError(error, fallbackMessage) {
      if (error.response && error.response.status === 422) {
        this.sv_errors.push(error.response.data.error);
      } else if (error.response && error.response.status === 404) {
        this.sv_errors.push(fallbackMessage);
      } else if (error.response && error.response.status === 500) {
        this.sv_errors.push("Internal Server Error");
      } else {
        console.log(error)
        this.sv_errors.push("Network error — check your connection and try again")
      }
    },
    async checkDomain() {
      this.IsChecking = true
      this.sv_errors = []
      try {
        this.allowed = await checkDomain(this.form.domain)
        this.isChecked = true
      }
      catch(error) {
        this.handleApiError(error, "Cannot get information for domain")
      }
      this.IsChecking = false
    },
    async addDomain() {
      this.IsAdding = true
      this.sv_errors = []
      try {
        const result = await addDomain(this.form.domain, this.concatenatedValues);
        console.log("Domain(s) added: " + result.accounts)
        if (result.errors) {
          result.errors.forEach(e => this.sv_errors.push(e.account + ": " + e.message))
        }
        if (result.allowed === undefined) {
          this.sv_errors.push("Domain may have been added but could not verify — try Check to confirm")
        }
        this.selectedValues = []
        this.allowed = result.allowed || this.allowed
      }
      catch(error) {
        this.handleApiError(error, "Problem adding account(s) for the domain")
      }
      this.IsAdding = false
    },
    async removeDomain() {
      this.IsRemoving = true
      this.sv_errors = []
      try{
        const result = await removeDomain(this.form.domain, this.concatenatedValues);
        console.log("Domain(s) removed: " + result.accounts)
        if (result.errors) {
          result.errors.forEach(e => this.sv_errors.push(e.account + ": " + e.message))
        }
        if (result.allowed === undefined) {
          this.sv_errors.push("Domain may have been removed but could not verify — try Check to confirm")
        }
        this.selectedValues = []
        this.allowed = result.allowed || this.allowed
      }
      catch(error) {
        this.handleApiError(error, "Problem removing account(s) for the domain")
      }
      this.IsRemoving = false
    }
  }
}
</script>